export type WarningType =
    | "offline"
    | "poor connection"
    | "low accuracy"
    | "high sensor reading"
    | "low sensor reading"
    | "zero sensor reading"
    | "misconfigured device"
    | "no network data"
    | "RTC sync error"
    | "frequent resets"
    | "failed verification"
    | "over watering"
    | "under watering"
    | "invalid sensor reading"
    | "damaged tensiometer"
    | "waiting for device"
    | "testing network"
    | "configuring sensor"
    | "Manual Override Engaged"
    | "sync paused"
    | "heat and frost protection";

/**
 * The severity level of a warning.
 *
 * - INFO (0): Informational only; does not indicate a problem.
 * - WARNING (1): Indicates a potential issue that may require attention.
 * - ERROR (2): Indicates a definite problem that requires action.
 */
export enum WarningLevel {
    INFO = 0,
    WARNING = 1,
    ERROR = 2,
}

export type WarningDescriptionOptions = {
    level?: WarningLevel | undefined;
    details?: string | undefined;
    title?: string | undefined;
    priority?: number | undefined;
    warningSourceKey?: string;
};
